import actionTypes from "consts/actionTypes.js";

const initialState = {
  user: {
    loading: false,
    data: undefined,
    error: undefined,
  },
  next: {
    loading: false,
    data: undefined,
    error: undefined,
  },
  update: {
    loading: false,
    data: undefined,
    error: undefined,
  },
};

export default (state = initialState, action) => {
    if (action['payload'] && action['payload'].error && action['payload'].error.code === -610) {
        action['payload'].error = null;
        action['payload'].status = true;
        action['payload'].result = {'calendar': []};
    }
  switch (action.type) {
    case actionTypes.CLEAN_APPOINTMENTS:
      return initialState;
    // USER APPOINTMENTS
    case actionTypes.GET_APPOINTMENTS_PENDING:
      return {
        ...state,
        user: {
          loading: true,
          error: undefined, // Empty error for retry
        },
      };
    case actionTypes.GET_APPOINTMENTS_SUCCESS:
      if (action.payload.status) {
        return {
          ...state,
          user: {
            loading: false,
            data: action.payload.result.calendar,
          },
        };
      } else {
        return {
          ...state,
          user: {
            loading: false,
            error: action.payload.error,
          },
        };
      }
    case actionTypes.GET_APPOINTMENTS_ERROR:
      return {
        ...state,
        user: {
          loading: false,
          error: action.error,
        },
      };

    // NEXT APPOINTMENTS
    case actionTypes.GET_NEXT_APPOINTMENTS_PENDING:
      return {
        ...state,
        next: {
          loading: true,
          error: undefined, // Empty error for retry
        },
        update: initialState.update,
      };
    case actionTypes.GET_NEXT_APPOINTMENTS_SUCCESS:
      if (action.payload.status) {
        return {
          ...state,
          next: {
            loading: false,
            data: action.payload.result.date,
          },
        };
      } else {
        return {
          ...state,
          next: {
            loading: false,
            error: action.payload.error,
          },
        };
      }
    case actionTypes.GET_NEXT_APPOINTMENTS_ERROR:
      return {
        ...state,
        next: {
          loading: false,
          error: action.error,
        },
      };
    case actionTypes.POST_UPDATE_APPOINTMENTS_PENDING:
      return {
        ...state,
        update: {
          loading: true,
        },
      };
    case actionTypes.POST_UPDATE_APPOINTMENTS_SUCCESS:
      if (action.payload.status) {
        return {
          ...state,
          update: {
            loading: false,
            data: action.payload.result,
          },
        };
      } else {
        return {
          ...state,
          update: {
            loading: false,
            error: action.payload.error,
          },
        };
      }
    case actionTypes.POST_UPDATE_APPOINTMENTS_ERROR:
      return {
        ...state,
        update: {
          loading: false,
          error: action.payload.error,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/appointments.js